import apiCall from 'apps/investcore/apiCalls/subscriptions';
import { DynamicFilterForm } from 'common/dynamic-filter-form';
import {
  CreatePage,
  DetailPage,
  EditPage,
  ListPage,
} from 'common/ui/admin-CRUD/page';
import { columnsGenerator } from './config';
import ItemDetail from './detail';
import ItemForm from './form';

export const SubscriptionsListPage = () => (
  <ListPage
    title="All Subscriptions"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    FilterForm={DynamicFilterForm}
    createUrl="/investment/subscriptions/create"
  />
);

export const SubscriptionsDetailPage = () => (
  <DetailPage
    title="Subscription"
    apiCall={apiCall}
    listUrl="/investment/subscriptions"
    ItemDetail={ItemDetail}
    options={{ editEnabled: true, deleteEnabled: true }}
  />
);

export const SubscriptionsEditPage = () => (
  <EditPage
    title="Subscription"
    apiCall={apiCall}
    listUrl="/investment/subscriptions"
    ItemForm={ItemForm}
  />
);

export const SubscriptionsCreatePage = () => (
  <CreatePage
    title="Subscription"
    apiCall={apiCall}
    listUrl="/investment/subscriptions"
    ItemForm={ItemForm}
  />
);
